import React, { FC } from 'react';
import { TypographyProps } from '@mui/material';

import { Typography } from '../Typography';
import { PaletteColor } from '../../palette';


export type CounterProps = Omit<TypographyProps, 'color' | 'bgcolor' | 'variant'> & {
    count: number | string;
    variant: 'primary' | 'secondary' | 'black';
    textVariant?: TypographyProps['variant'];
    gray?: boolean;
    active?: boolean;
    sx?: TypographyProps['sx'];
}

const bgColors: Record<CounterProps['variant'], PaletteColor> = {
    primary: 'infoCustom.red50',
    secondary: 'grayscale.shade0',
    black: 'grayscale.shade10',
};

const textColors: Record<CounterProps['variant'], PaletteColor> = {
    primary: 'grayscale.shade0',
    secondary: 'infoCustom.red50',
    black: 'grayscale.shade95',
};


export const Counter: FC<CounterProps> = ({
    count,
    variant = 'primary',
    textVariant = 'boldCaption2',
    gray,
    active,
    sx,
    ...props
}) => (
    <Typography
        variant={textVariant}
        sx={{
            minWidth: ({ spacing }) => spacing(5),
            borderRadius: 3,
            backgroundColor: ({ palette: { grayscale } }) =>
                gray ? grayscale.shade40 : bgColors[active ? 'secondary' : variant],
            color: ({ palette: { grayscale } }) =>
                gray ? grayscale.shade85 : textColors[active ? 'secondary' : variant],
            ...sx,
        }}
        {...props}
    >
        {count}
    </Typography>
);
